<template>
  <div class="base-mit-ldap-users">
      <v-autocomplete
        :clearable="clearable"
        :solo="solo"
        :outlined="outlined"
        :dense="dense"
        :label="label"
        :chips="multiSelect"
        :deletable-chips="multiSelect"
        :multiple="multiSelect"
        color="primary"
        v-model="selectedUsers"
        :items="userList"
        :cache-items="multiSelect"
        :search-input.sync="userSearch"
        :loading="loading"
        loader-height="5"
        item-text="id"
        :return-object="returnObject"
        no-data-text="Enter text to get users..."
        v-on:change="userChanged"
      >
          <template v-if="multiSelect" v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeChip(data.item)"
            >
              {{ data.item.name || data.item.id }}
            </v-chip>
          </template>
          <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>{{data.item.id}}</v-list-item-title>
                <v-list-item-subtitle>{{data.item.email}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{data.item.name}}</v-list-item-subtitle>
              </v-list-item-content>
          </template>
      </v-autocomplete>
  </div>
</template>

<script>
import BaseMitCSAILLdapService from '../../services/BaseMitCSAILLdapService.js';

export default {
  name: 'BaseMitCSAILUsers',
  components: {},
  props: {
      selectedUsers:{
         type: Array,
         default() {
             return []
         }
      },
    multiSelect:{
      default: false,
      type: Boolean
    },
    returnObject:{
      default: false,
      type: Boolean
    },
    clearable:{
      default: true,
      type: Boolean
    },
    solo:{
      default: true,
      type: Boolean
    },
    outlined:{
      default: false,
      type: Boolean
    },
    dense:{
      default: true,
      type: Boolean
    },
    label:{
        default: 'Select User',
        type: String
    }
  },
  data: function() {
    return {
        loading:false,
        userSearchTerm:'',
        userList:[]
    }
  },
  created(){
      console.log('User base - Created');
      //look up the user info for any default selected users for this control.
      //This way we can show other info like full name.
      //This will only work by default, it won't work if users change the values after first render.
      if(this.selectedUsers.length > 0){
          this.populateSpecificUsers(this.selectedUsers);
      }

      this.$emit('user-changed',this.selectedUsers);
  },
  mounted(){
      console.log('User base - Mounted');
  },
  computed: {
      userSearch: {
        get () {
          return this.userSearchTerm
        },
        set (searchInput) {
          if (this.userSearchTerm !== searchInput) {
            this.userSearchTerm = searchInput
            this.getCsailUsers(this.userSearchTerm);
          }
        }
      }
  },
  methods: {
      // clearSearchTerm(){
      //     this.userSearchTerm = '';
      // },
      // setUsers(list){
      //     if(list.length > 0){
      //         this.removeAllUsers();
      //         this.addUsers(list);
      //         this.populateSpecificUsers(list);
      //     }
      // },
      // addUsers(list){
      //     for(let x = 0; x < list.length; x++){
      //         this.selectedUsers.push(list[x]);
      //     }
      // },
      // removeAllUsers(){
      //     this.selectedUsers.splice(0,this.selectedUsers.length)
      // },
      populateSpecificUsers(list){
          BaseMitCSAILLdapService.requestGetUsersInfo(list)
            .then((data) => {
              this.userList = data.users;
            })
            .catch((error) => {
                console.log('Failed to fetch initial users data.')
            });
      },
      removeChip (item) {
        let index = -1;
        for(let x = 0; x < this.selectedUsers.length; x++){
          if(this.selectedUsers[x] === item.id || (this.selectedUsers[x].id && this.selectedUsers[x] === item.id)){
            index = x;
            break;
          }
        }
        if (index >= 0) this.selectedUsers.splice(index, 1)
      },
      userChanged(event){
          this.$emit('user-changed',event);
      },
      getCsailUsers(searchterm){
            this.loading = true;
            BaseMitCSAILLdapService.requestGetUsers(searchterm)
              .then((data) => {
                this.userList = data.users;
                this.loading = false;
              })
              .catch((error) => {
                this.userList = [];
                this.loading = false;
              });
      }
  }
}
</script>

<style lang="scss" scoped>
</style>
